export class OrgTeam {

  private static StringKeys = ['clubName', 'eventName', 'headCoach', 'headCoachEmail', 'headCoachPhone', 'teamGender', 'teamImage', 'teamName'];
  private static NumKeys = ['divisionID', 'dpPlayers', 'dpPlayersSpots', 'eventID', 'firstTeamPlayer', 'teamID', 'totalPlayersSpots'];

  clubName: string;
  divisionID: number;
  dpPlayers: number;
  dpPlayersSpots: number;
  eventID: number;
  eventName: string;
  firstTeamPlayer: number;
  headCoach: string;
  headCoachEmail: string;
  headCoachPhone: string;
  teamGender: string;
  teamID: number;
  teamImage: string;
  teamName: string;
  totalPlayersSpots: number;

  constructor(data) {
    OrgTeam.NumKeys.forEach(n => this[n] = +data[n] || 0);
    OrgTeam.StringKeys.forEach(s => this[s] = data[s] || '');
    this.teamGender = this.teamGender.toLowerCase();
  }
}

export class TeamsList {

  clubOrgTeamList: OrgTeam[];
  totalFemaleTeams: number;
  totalMaleTeams: number;
  totalTeams: number;

  constructor(data) {
    this.clubOrgTeamList = (data || []).map(t => new OrgTeam(t));
    this.totalFemaleTeams = this.clubOrgTeamList.filter(t => t.teamGender === 'f').length;
    this.totalMaleTeams = this.clubOrgTeamList.filter(t => t.teamGender === 'm').length;
    this.totalTeams = this.clubOrgTeamList.length;
  }

}

export class TeamCounts {
  totalFemaleTeams: number;
  totalMaleTeams: number;
  totalTeams: number;
}

export class ClubTeam {

  private static StringKeys = ['teamName', 'teamGender', 'clubName', 'clubLogo', 'headCoach'];
  private static NumKeys = ['teamID', 'clubID', 'totalFirstTeamPlayers', 'totalGuestTeamPlayers'];

  teamID: number;
  teamName: string;
  teamGender: string;
  clubID: number;
  clubName: string;
  clubLogo: string;
  headCoach: string;
  totalFirstTeamPlayers: number;
  totalGuestTeamPlayers: number;

  constructor(data) {
    ClubTeam.NumKeys.forEach(n => this[n] = +data[n] || 0);
    ClubTeam.StringKeys.forEach(s => this[s] = data[s] || '');
    this.teamGender = this.teamGender.toLowerCase();
  }
}

export class ClubTeamsList {

  clubOrgTeamList: ClubTeam[];
  totalFemaleTeams: number;
  totalMaleTeams: number;
  totalTeams: number;

  constructor(data) {
    this.clubOrgTeamList = (data || []).map(t => new ClubTeam(t));
    this.totalFemaleTeams = this.clubOrgTeamList.filter(t => t.teamGender === 'f').length;
    this.totalMaleTeams = this.clubOrgTeamList.filter(t => t.teamGender === 'm').length;
    this.totalTeams = this.clubOrgTeamList.length;
  }

}



// WEBPACK FOOTER //
// ./src/app/models/association/teams-list.ts